import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { lookupEmailByUsernameAPI } from '../services/serverService';

export default function LoginPage() {
    const [serverId, setServerId] = useState('');
    const [loginId, setLoginId] = useState(''); // This is the Username
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    const { login } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);

            const cleanUsername = loginId.trim();
            const cleanServerId = serverId.trim();

            // STEP 1: The Pre-Flight Proxy Lookup
            const lookupResponse = await lookupEmailByUsernameAPI(cleanServerId, cleanUsername);
            const realEmail = lookupResponse.data.email;

            if (!realEmail) {
                throw new Error("No email associated with this account.");
            }

            // STEP 2: Set the routing target for AuthContext
            if (cleanServerId) {
                localStorage.setItem('targetLoginServer', cleanServerId);
            } else {
                localStorage.removeItem('targetLoginServer');
            }

            // Save the exact username so AuthContext doesn't confuse Dev/Support
            localStorage.setItem('loginUsername', cleanUsername);

            // STEP 3: Silently log into Firebase Auth using the real email
            await login(realEmail, password);
            navigate('/servers'); 
            
        } catch (err) {
            console.error("Login Proxy Error:", err);
            const apiMessage = err.response?.data?.message;
            setError(apiMessage || 'Failed to log in. Please check your Server ID, Username, and Password.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f6f8', position: 'relative' }}>
            <div style={{ padding: '40px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>System Login</h2>
                
                {error && <div style={{ backgroundColor: '#ffdddd', color: 'red', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '14px' }}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Server ID</label>
                        <input 
                            type="text" 
                            placeholder="e.g., architecture.care (Leave blank if Global Admin)"
                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' }}
                            value={serverId}
                            onChange={(e) => setServerId(e.target.value.toLowerCase())}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Username</label>
                        <input 
                            type="text" 
                            required 
                            placeholder="Enter username"
                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' }}
                            value={loginId}
                            onChange={(e) => setLoginId(e.target.value)}
                        />
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>Password</label>
                        <input 
                            type="password" 
                            required 
                            placeholder="Enter password"
                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button 
                        disabled={loading} 
                        type="submit" 
                        style={{ width: '100%', padding: '12px', backgroundColor: '#0056b3', color: 'white', border: 'none', borderRadius: '4px', cursor: loading ? 'not-allowed' : 'pointer', fontSize: '16px', fontWeight: 'bold' }}
                    >
                        {loading ? 'Authenticating...' : 'Log In'}
                    </button>
                </form>
            </div>

            <div style={{ position: 'absolute', bottom: '20px', right: '20px', color: '#a0aec0', fontSize: '14px', fontWeight: 'bold', fontFamily: 'monospace', backgroundColor: 'rgba(0,0,0,0.05)', padding: '5px 10px', borderRadius: '5px' }}>
                v2.0.17
            </div>
        </div>
    );
}